











































import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import RemoveItemModal from '../components/general/RemoveItemModal.vue'
import { CIcon } from '@coreui/icons-vue'
import { cilUserFemalePlus } from '@coreui/icons-pro'
import AddAdminUserModal from '../components/adminUsers/AddAdminUserModal.vue'

interface Item {
  id: number
  fullName: string
}

export default Vue.extend({
  data: function () {
    return {
      loading: true,
      showDeleteDialog: false,
      showAddDialog: false,
      deleteItem: { id: 0, fullName: '' },
      records: [],
      headers: [
        { text: 'Email', value: 'email' },
        { text: 'Full Name', value: 'fullName' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Created On', value: 'createdDate' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      userAddIcon: cilUserFemalePlus,
    }
  },
  mounted: async function () {
    this.records = await (await fetch('/api/portaladmin/users')).json()
    this.loading = false
  },
  methods: {
    openDelete(item: Item) {
      this.showDeleteDialog = true
      this.deleteItem = item
    },
    async deleteItemOnServer(id: number) {
      await (
        await fetch(`/api/portaladmin/users/${id}`, {
          method: 'DELETE',
        })
      ).json()
      this.loading = true
      this.records = await (await fetch('/api/portaladmin/users')).json()
      this.loading = false
      this.showDeleteDialog = false
    },
    async userAdded() {
      this.loading = true
      this.records = await (await fetch('/api/portaladmin/users')).json()
      this.loading = false
      this.showAddDialog = false
    },
  },
  components: {
    ScreenTile,
    RemoveItemModal,
    CIcon,
    AddAdminUserModal,
  },
})
